module.exports = __webpack_public_path__ + "img/6.950b182d.jpg";